import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { AuthHubService } from './services/auth-hub.service';
import { AuthorizationMonitorService } from './services/authorization-monitor.service';
import { LoginButtonComponent } from './components/login-button.component';
import { LogoutButtonComponent } from './components/logout-button.component';
import { ProfileComponent } from './components/profile.component';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [AsyncPipe, RouterOutlet, RouterLink, RouterLinkActive, LoginButtonComponent, LogoutButtonComponent, ProfileComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly auth = inject(AuthService);
  protected readonly authHub = inject(AuthHubService);
  private readonly router = inject(Router);
  // ensures authorization is monitored for the lifetime of the app root
  private readonly _authMonitor = inject(AuthorizationMonitorService);

  title = 'Client Management Portal';
  version = this.formatVersionFromTag(environment.version);

  private formatVersionFromTag(tag: string): string {

    console.log('Raw version tag:', tag);
    const numbers = tag.replace(/^[a-z]*/, ''); // Rimuove il prefisso non numerico)

    // if less than 3 numbers, return the original tag
    if(numbers.length < 3) {
      return tag;
    }

    const major = numbers.charAt(0);
    const minor = numbers.charAt(1);
    const patch = numbers.substring(2);

    // removing zeroes at the end of patch
    patch.replace(/0+$/, '') || '0';

    return `${major}.${minor}.${patch}`;
  }

}
